// extracted by mini-css-extract-plugin
var _1 = "collapsible__qlxBj";
var _2 = "container__A1yS2";
var _3 = "expanded__nezG9";
var _4 = "more-block__hVhwN";
var _5 = "more-inline__wFhTH";
export { _1 as "collapsible", _2 as "container", _3 as "expanded", _4 as "moreBlock", _5 as "moreInline" }
